
export default function HeroBanner() {
  const scrollToProducts = () => {
    const element = document.getElementById('product-categories');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToStockist = () => {
    const element = document.getElementById('stockist-cta');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full overflow-hidden pt-[64px] md:pt-[72px]">
      {/* Desktop: full background image */}
      <div className="absolute inset-0 bg-[#1a1a1a] hidden md:block">
        <img
          src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/235de1fe1b174385b4f26b08dc3d22f9.png"
          alt="BEST Products Hero"
          className="w-full h-full object-contain object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/10 hidden md:block"></div>

      {/* Mobile layout: stacked */}
      <div className="relative z-10 w-full flex flex-col md:flex-row md:min-h-[85vh] md:items-center">
        {/* Text block */}
        <div className="w-full bg-[#1A1A1A] md:bg-transparent px-4 md:px-8 lg:px-16 xl:px-24 py-10 md:py-20 md:max-w-[680px]">
          <h1
            className="font-black text-[32px] md:text-[68px] leading-[1.1] text-white mb-4 md:mb-6"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Built to Bond.<br />Made to Last.
          </h1>
          <p
            className="text-[15px] md:text-[22px] text-[#DDDDDD] leading-[1.6] mb-8 md:mb-12 max-w-full md:max-w-[560px]"
            style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}
          >
            Professional-grade tile adhesive, grout, paint, and bonding liquid. Trusted by contractors and DIYers across the country.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-5">
            <button
              onClick={scrollToProducts}
              className="bg-[#F2C612] text-black px-8 py-4 rounded text-[15px] md:text-[16px] font-semibold hover:shadow-lg transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer w-full sm:w-auto min-h-[48px] md:h-[58px] flex items-center justify-center"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Explore Our Products
            </button>
            <button
              onClick={scrollToStockist}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded text-[15px] md:text-[16px] font-semibold hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer w-full sm:w-auto min-h-[48px] md:h-[58px] flex items-center justify-center"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Become a Stockist
            </button>
          </div>
        </div>

        {/* Mobile product image — below text */}
        <div className="w-full md:hidden bg-[#1a1a1a]">
          <img
            src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/235de1fe1b174385b4f26b08dc3d22f9.png"
            alt="BEST Products"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}
